import React, { useState } from 'react'
import { Icon, Modal, Tooltip } from "antd"

function AttachTagSpecifications(props) {
    const { processingOrder } = props
    const { brand, brandKit, thankCard} = processingOrder

    const [isOpenPreview, setIsOpenPreview] = useState(false)
    const [preview, setPreview] = useState('')

    const handleShowPreview = (url) => {
        setIsOpenPreview(true)
        setPreview(url)
    }

    const handleClosePreview = () => {
        setIsOpenPreview(false)
        setPreview('')
    }

    const BrandBlock = () => {
        return (
            <div className={["Block BrandBlock", (isThankCard() || isBrandKit()) && 'HasThankCardOrBrandKit'].filter(Boolean).join(' ')}>
                <div className="row">
                    <div className="col-12 ColName">
                        <div className="brand-title">
                            Brand <span className="InfoBrand badge text-bg-danger ml-4">{brand.name}</span>
                        </div>
                        <div className="ColContent">
                            {
                                !!(packagingTags && packagingTags.length) &&
                                <div className="ListTags">
                                    {
                                        packagingTags.map(tag => {
                                            const { id, name = '', quantity_per_item = 1, description = '', note = '', design = '' } = Object.assign({}, tag)
                                            return (
                                                <div className="row mb-3" key={id}>
                                                    <div className="col-md-6">
                                                        <Tooltip title={note} placement={"right"}>
                                                            <div style={{ wordWrap: 'break-word' }}>
                                                                {
                                                                    [
                                                                        <span>{name}</span>,
                                                                        <span>(Qty = {quantity_per_item})</span>,
                                                                        description && <span>: {description}</span>
                                                                    ].filter(Boolean)
                                                                }
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {
                                                            !!design &&
                                                            <div className="images-brand posititon-relative">
                                                                <img src={design} alt='preview' width={300} loading='lazy' />
                                                                <div className='Icon'>
                                                                    <Icon className='eye-icon' type="eye" onClick={() => handleShowPreview(design)} />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const packagingTags = brand && brand.rule && brand.rule.current_tags ? brand.rule.current_tags.filter(tag => tag.type === 'packaging') : []
    const hasBrand = !!packagingTags.length
    const isThankCard = () => !!(thankCard && thankCard.length)
    const isBrandKit = () => !!(brandKit && brandKit.length)

    return (
        <div className={`MarkPackagedPageSpecifications`}>
            <div className="header-content BoxHeading d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="mb-0">Quy cách tag mác</h3>
            </div>
            <div className="BoxContent">
                <div className={["Block PackedDescriptionBlock pb-3", (isThankCard() || isBrandKit() || hasBrand) && 'HasThankCardOrBrandKit'].filter(Boolean).join(' ')}>
                        <div className="row">
                            <div className="col-md-12 ColName">Mô tả tag mác</div>
                        </div>
                </div>

                {
                    !!preview && isOpenPreview &&
                    <Modal
                        visible={isOpenPreview}
                        onCancel={handleClosePreview}
                        closable={false}
                        footer={false}
                        width={"50vw"}
                        height={"75vh"}
                    >
                        <img
                            src={preview}
                            alt="preview"
                            width={"100%"}
                            style={{ objectFit: 'contain' }}
                        />
                    </Modal>
                }

                {
                    hasBrand && <BrandBlock />
                }
            </div>
        </div>
    )
}

export default AttachTagSpecifications